var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99995 10.8866C6.40661 10.8866 5.11328 9.59328 5.11328 7.99995C5.11328 6.40661 6.40661 5.11328 7.99995 5.11328C9.59328 5.11328 10.8866 6.40661 10.8866 7.99995C10.8866 9.59328 9.59328 10.8866 7.99995 10.8866ZM7.99995 6.11328C6.95995 6.11328 6.11328 6.95995 6.11328 7.99995C6.11328 9.03995 6.95995 9.88661 7.99995 9.88661C9.03995 9.88661 9.88661 9.03995 9.88661 7.99995C9.88661 6.95995 9.03995 6.11328 7.99995 6.11328Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00022 14.0134C5.49355 14.0134 3.12688 12.5467 1.50021 10C0.793548 8.90003 0.793548 7.10669 1.50021 6.00003C3.13355 3.45336 5.50022 1.98669 8.00022 1.98669C10.5002 1.98669 12.8669 3.45336 14.4935 6.00003C15.2002 7.10003 15.2002 8.89336 14.4935 10C12.8669 12.5467 10.5002 14.0134 8.00022 14.0134ZM8.00022 2.98669C5.84688 2.98669 3.78688 4.28003 2.34688 6.54003C1.84688 7.32003 1.84688 8.68003 2.34688 9.46003C3.78688 11.72 5.84688 13.0134 8.00022 13.0134C10.1535 13.0134 12.2135 11.72 13.6535 9.46003C14.1535 8.68003 14.1535 7.32003 13.6535 6.54003C12.2135 4.28003 10.1535 2.98669 8.00022 2.98669Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye-on.47cfc5fa9154db78dad4dc44e9c0537e.svg";
export { ForwardRef as ReactComponent };